import { render, staticRenderFns } from "./recipientInformation.vue?vue&type=template&id=0fde4bc7&scoped=true&"
import script from "./recipientInformation.vue?vue&type=script&lang=js&"
export * from "./recipientInformation.vue?vue&type=script&lang=js&"
import style0 from "./recipientInformation.vue?vue&type=style&index=0&id=0fde4bc7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fde4bc7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
